const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const StepWrapper = require("./StepWrapper");

const styles = require("./styles/SetUsername.css");

module.exports = createReactClass({
	displayName: "SetUsername",

	propTypes: {
		studentData: PT.object.isRequired,
		copy: PT.object.isRequired,
		renderButton: PT.func.isRequired,
		handleSubmit: PT.func.isRequired,
		onChange: PT.func.isRequired,
		handleRequestRandomUsernames: PT.func.isRequired,
		possibleUsernames: PT.array.isRequired,
		stepNumber: PT.number.isRequired,
		totalNumSteps: PT.number.isRequired,
		handleBack: PT.func,
	},

	getInitialState: function() {
		return {
			selectedIndex: null,
		};
	},

	UNSAFE_componentWillReceiveProps: function(nextProps) {
		//If the list of usernames changes, unselect the currently selected option
		if (!_.isEqual(nextProps.possibleUsernames, this.props.possibleUsernames)) {
			this.setState({selectedIndex: null});
		}
	},

	getKeyHandler: function(f) {
		return evt => {
			if (evt.which === 13) {
				f();
			}
		};
	},

	chooseUsername: function(index) {
		if (this.state.selectedIndex === index) {
			this.setState({selectedIndex: null});
		} else {
			this.setState({selectedIndex: index});
		}
		this.props.onChange();
	},

	handleSubmit: function() {
		let username = null;
		if (_.isNumber(this.state.selectedIndex)) {
			username = this.props.possibleUsernames[this.state.selectedIndex].join(
				""
			);
		}
		this.props.handleSubmit(username);
	},

	renderUsernames: function() {
		return _.map(this.props.possibleUsernames, (u, i) => {
			const onClick = () => this.chooseUsername(i);
			const selected = i === this.state.selectedIndex;
			let className = selected ? styles.selected : styles.possible;
			className += " " + styles.username;
			return (
				<div
					key={"u-" + i}
					className={className}
					onClick={onClick}
					onKeyPress={this.getKeyHandler(onClick)}
					tabIndex={0}
				>
					{u}
				</div>
			);
		});
	},

	render: function() {
		const wrapperProps = _.pick(this.props, [
			"copy",
			"renderButton",
			"renderError",
			"stepNumber",
			"totalNumSteps",
			"handleBack",
		]);

		return (
			<StepWrapper {...wrapperProps} handleSubmit={this.handleSubmit}>
				<div className={styles.userNameContainer}>{this.renderUsernames()}</div>
				<div
					className={styles.more}
					onClick={this.props.handleRequestRandomUsernames}
					onKeyPress={this.getKeyHandler(
						this.props.handleRequestRandomUsernames
					)}
					tabIndex={0}
				>
					<span className={styles.plus}>{"+"}</span>
					{" Get more usernames"}
				</div>
			</StepWrapper>
		);
	},
});
